import Glide, { Breakpoints } from '@glidejs/glide';


$(function() {

	/**
	 *  Preload
	 */

	$(window).on('load', function() {
		$('html').removeClass('prevent-onload-transitions');
	});



    /**
     * subnavigation set topnavigtion active
     */

    if($('#menu-aboutusmenu').length) {
        $('#menu-item-93').addClass('current-menu-item');
    }

    if($('body.tax-leistungskategorie , body.single-leistungen').length) {
        $('#menu-item-52').addClass('current-menu-item');
    }

    if($('body.tax-referenzkategorie , body.single-referenzen').length) {
        $('#menu-item-23').addClass('current-menu-item');
    }

    


    // INTERFERER  / STÖRER
    $('#hideInterferer').on('click', function(){
        $(this).parent().toggleClass('is-invisible');
    });


	/**
	 * External link
	 */

	var host = window.location.hostname;
    var domain = host.replace("www.", "");
    $('a[href^="http"]')
        .not('a[href*="' + domain + '"]')
        .attr("target", "_blank");

	$("a[href$='.pdf']").attr("target", "_blank");



    /**
     *	Map
     */
    if($('.m-map').length) {
        $('.m-map').each(function () {
            // create map
            new_map($(this));

        });
    }
	/**
	 * Responsive
	 */

	var browserWidth = $(window).innerWidth();
	var browserHeight = $(window).innerHeight();

	$(window).on('resize', function() {
		browserWidth = $(window).innerWidth();
		browserHeight = $(window).innerHeight();

		if ( browserWidth <= 900 ) {
			// Do something
		} else {
			// Do something
		}
	});

    $('.l-header').on('click', '#m-hamburger:not(.m-hamburger--active)', function(){
        $(this).addClass('m-hamburger--active');
        $('.m-menu').addClass('m-menu--visible');
    });

    $('.l-header').on('click', '#m-hamburger.m-hamburger--active', function(){
        $(this).removeClass('m-hamburger--active');
        $('.m-menu').removeClass('m-menu--visible');
    });

    /**
     * Filter
     */
    $('.l-main').on('click', '.m-filter:not(.m-filter--active)', function(){
        $(this).addClass('m-filter--active').next('.m-filtermenu').addClass('m-filtermenu--visible');
    });

    $('.l-main').on('click', '.m-filter.m-filter--active', function(){
        $(this).removeClass('m-filter--active').next('.m-filtermenu').removeClass('m-filtermenu--visible');
    });

    /*
        if($('.m-gallery').length) {

            var sliders = document.querySelectorAll('.m-gallery');

            for (var i = 0; i < sliders.length; i++) {
                var glide = new Glide(sliders[i], {
                    type: 'carousel',
                    gap: '25',
                    perView: 2,
                    breakpoints: {
                        767: {
                            perView: 1
                        }

                    }
                });

                glide.mount();
            }

        }
    */


    $('[data-fancybox="gallery"]').fancybox({


        animationEffect: false,
        infobar: false,
        showCloseButton : true,
        autoFocus : true,
        titlePosition 		: 'inside',

        baseTpl	: '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-controls">' +
            '<div class="fancybox-infobar">' +
            '<button data-fancybox-prev title="{{PREV}}" class="fancybox-button fancybox-button--left"></button>' +
            '<div class="fancybox-infobar__body">' +
            '<span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span>' +
            '</div>' +
            '<button data-fancybox-next title="{{NEXT}}" class="fancybox-button fancybox-button--right"></button>' +
            '</div>' +
            '</div>' +
            '<div class="fancybox-toolbar">' +
            '{{buttons}}' +
            '</div>' +
            '<div class="fancybox-navigation">' +
            '<button data-fancybox-prev title="{{PREV}}" class="fancybox-arrow fancybox-arrow--left" />' +
            '<button data-fancybox-next title="{{NEXT}}" class="fancybox-arrow fancybox-arrow--right" />' +
            '</div>' +
            '<div class="fancybox-stage"></div>' +
            '<div class="fancybox-caption-wrap">' +
            '<div class="fancybox-caption"></div>' +
            '</div>' +
            '</div>' +
            '</div>',

        onInit : function( instance ) {

        }

    });

        if($('.glide').length) {


            var carousel = new Glide('.glide', {
                type: 'carousel',
                autoplay: '5000',
                focusAt: 'center',
                perView: 1
            })
            carousel.mount();

        }
});

/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map( $el ) {

    // vars
    var args = {
        zoom		: 16,
        center		: new google.maps.LatLng(0, 0),
        mapTypeId	: google.maps.MapTypeId.ROADMAP,
        styles 		: [{
            "stylers": [{
                "saturation" : -100
            }]
        }]
    };

    // create map
    var map = new google.maps.Map( $el[0], args);

    // Change map to greyscale
    var mapstyle = [{"elementType": "geometry", "stylers": [{"color": "#f5f5f5"} ] }, {"elementType": "labels.icon", "stylers": [{"visibility": "off"} ] }, {"elementType": "labels.text.fill", "stylers": [{"color": "#616161"} ] }, {"elementType": "labels.text.stroke", "stylers": [{"color": "#f5f5f5"} ] }, {"featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{"color": "#bdbdbd"} ] }, {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#eeeeee"} ] }, {"featureType": "poi", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"} ] }, {"featureType": "poi.park", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"} ] }, {"featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"} ] }, {"featureType": "road", "elementType": "geometry", "stylers": [{"color": "#ffffff"} ] }, {"featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{"color": "#757575"} ] }, {"featureType": "road.highway", "elementType": "geometry", "stylers": [{"color": "#dadada"} ] }, {"featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{"color": "#616161"} ] }, {"featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"} ] }, {"featureType": "transit.line", "elementType": "geometry", "stylers": [{"color": "#e5e5e5"} ] }, {"featureType": "transit.station", "elementType": "geometry", "stylers": [{"color": "#eeeeee"} ] }, {"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#c9c9c9"} ] }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#9e9e9e"} ] } ];

    map.setOptions({ styles: mapstyle });

    // add a markers reference
    map.markers = [];

    // add markers
    $el.each(function(){

        add_marker( $(this), map );

    });

    // center map
    center_map( map );


    // return
    return map;

}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map ) {

    var pinImage =  new google.maps.MarkerImage( template_url + '/assets/images/map_marker.svg' );

    var image = {
        url: template_url + '/assets/images/map_marker.svg',
        size: new google.maps.Size(56, 69),
        scaledSize: new google.maps.Size(56, 69), // IE needed
        anchor: new google.maps.Point(25, 55)
    };

    // var
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

    // create marker
    var marker = new google.maps.Marker({
        position	: latlng,
        map			: map,
        optimized	: false, // IE needed
        icon		: image
    });

    // add to array
    map.markers.push( marker );

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){

        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

    });

    // only 1 marker?
    if( map.markers.length == 1 )
    {
        // set center of map
        map.setCenter( bounds.getCenter() );
        map.setZoom( 16 );
    }
    else
    {
        // fit to bounds
        map.fitBounds( bounds );
    }

}


// WEBPACK FOOTER //
// ./assets/scripts/main.js